/** Fetches a remote file (e.g. an already-uploaded document) and wraps it as a
 *  File, so it can be re-submitted through a multipart form. Needed because the
 *  billing update endpoint replaces the whole document pack — every file that
 *  should be kept must be sent again.
 *  Throws on a non-OK response (download links are signed with a 1h TTL, so an
 *  expired link must fail loudly instead of wrapping the error body as a file). */
export const urlToFile = async (url: string, name: string, mimeType: string): Promise<File> => {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Failed to fetch file "${name}": ${response.status}`)
  }

  const blob = await response.blob()

  return new File([blob], name, { type: mimeType })
}
